import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMoreVerComponent } from "./med-icon-more-ver.component";

@NgModule({
  declarations: [
    MedIconMoreVerComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMoreVerComponent,
  ],
})
export class MedIconMoreVerModule { }
